var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.04405C19.4116 7.29787 18.7713 7.48054 18.1118 7.55168C18.7965 7.14488 19.3093 6.50219 19.5539 5.74421C18.9113 6.12645 18.2074 6.39448 17.4734 6.53642C17.1666 6.20843 16.7955 5.94715 16.3833 5.76884C15.9711 5.59053 15.5266 5.49902 15.0775 5.50001C13.2604 5.50001 11.7991 6.97291 11.7991 8.78038C11.7991 9.0342 11.8298 9.28801 11.8798 9.53222C9.159 9.38993 6.73236 8.09008 5.1191 6.09994C4.82514 6.60202 4.6711 7.1737 4.673 7.75551C4.673 8.89383 5.25177 9.89756 6.13436 10.4879C5.61424 10.4674 5.1063 10.3244 4.65184 10.0706V10.111C4.65184 11.705 5.77863 13.026 7.28038 13.3298C6.99841 13.4031 6.70834 13.4405 6.41702 13.4414C6.20358 13.4414 6.00168 13.4202 5.79786 13.3914C6.2132 14.6912 7.42267 15.6353 8.86288 15.6661C7.73609 16.5487 6.32472 17.0678 4.79221 17.0678C4.51725 17.0678 4.26343 17.0582 4 17.0275C5.45367 17.96 7.17846 18.4984 9.03593 18.4984C15.066 18.4984 18.3656 13.5029 18.3656 9.16687C18.3656 9.02458 18.3656 8.88229 18.356 8.74C18.9944 8.27275 19.5539 7.69397 20 7.04405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFilled);
export default __webpack_public_path__ + "static/media/twitter_filled.f702c84efec561cb62f014f85e9170b4.svg";
export { ForwardRef as ReactComponent };